import supabase from '../utils/supabaseClient';

// Data-access layer for the `app_settings` key/value table.
// Same contract as src/data/familias.js: resolves to plain data, throws the
// Supabase error on failure.

const CATALOGUE_MODE_KEY = 'catalogue_mode';

/**
 * Whether Catalogue Mode is on (prices hidden site-wide).
 * @returns {Promise<boolean>}
 */
export async function getCatalogueMode() {
  const { data, error } = await supabase
    .from('app_settings')
    .select('value')
    .eq('key', CATALOGUE_MODE_KEY)
    .maybeSingle();

  if (error) throw error;
  return data?.value === 'true';
}

/**
 * Turn Catalogue Mode on or off. Requires an authenticated (admin) session.
 * @param {boolean} enabled
 * @returns {Promise<void>}
 */
export async function setCatalogueMode(enabled) {
  const { error } = await supabase
    .from('app_settings')
    .update({ value: enabled ? 'true' : 'false', updated_at: new Date().toISOString() })
    .eq('key', CATALOGUE_MODE_KEY);

  if (error) throw error;
}
